const messages = {
  CONFIRMAR_CANCELAR: 'Ao cancelar, todos os dados serão perdidos. Deseja confirmar esta ação?',
  TITLE_ATENCAO: 'Atenção!',
  TIPO_ERROR: 'error',
  TIPO_INFO: 'info',
  TIPO_SUCCESS: 'success',
  TIPO_WARNING: 'warning',
  TITULO_ERROR: 'Erro!',
  TITULO_NOVOS_PROCESSOS: 'Processos atualizados',
  TITULO_FINISH: 'Finalizar',
  TITULO_SUCCESS: 'Sucesso!',
  TITULO_WARNING: 'Atenção!',
  ERROR_MESSAGE: 'Ocorreu um erro inesperado, tente novamente mais tarde.',
  DOCUMENTO_REMOVE_CONFIRM: 'Tem certeza que deseja remover o documento?',
  CREDENCIAR_CONFIRM: 'Tem certeza que deseja credenciar o processo?',
  ERRO_VALIDACAO_FINALIZAR_CADASTRO: 'É necessário preencher os campos obrigatórios para finalizar o cadastro.',
  WARNING_VALIDACAO_FINALIZAR_CADASTRO: 'Para finalizar o cadastro preencha corretamente todos os campos destacados.',
  ERRO_VALIDACAO_FINALIZAR_VALIDACAO: 'É necessário preencher os campos obrigatórios para finalizar a validação.',
  CANCELAR_CADASTRO: 'Ao cancelar este cadastro, os dados preenchidos não serão salvos. Deseja confirmar esta ação?',
  CANCELAR_VALIDACAO: 'Tem certeza que deseja cancelar esta validação?',
  VALIDACAO_SUCESSO: 'Solicitação de credenciado validada com sucesso.',
  CADASTRADO_SUCESSO: 'Solicitação de credenciado cadastrada com sucesso.',
  ERRO_CREDENCIAMENTO: 'Erro ao credenciar processo, tente novamente mais tarde',
  SOLICITACAO_RETIFICADA_SUCESSO: "Solicitação retificada com sucesso.",
  SOLICITACAO_EDITADA_SUCESSO: 'Edição de solicitação efetuada com sucesso.',
  ERRO_EDICAO_SOLICITACAO: 'Esta solicitação não pode ser editada, pois a retificação da mesma não foi solicitada.',

  CREDENCIADO_CADASTRADO_EDITAL: 'CPF já cadastrado para o edital vigente.',
  SEM_EDITAL_VIGENTE: 'Não existe edital em andamento',
  RETIFICACAO_SOLICITADA: 'Retificação solicitada com sucesso!',
  ARQUIVO_INVALIDO_TAMANHO: 'O tamanho máximo permitido é de 15MB',
  ARQUIVO_INVALIDO_FORMATO: 'Arquivo inválido, permitido apenas PDF.',
  LIMITE_EXCEDIDO_ARQUIVO: 'É permitido anexar apenas um arquivo.',
  MODELO_CADASTRADO: 'Modelo cadastrado com sucesso.',
  MODELO_EDITADO: 'Modelo editado com sucesso.',
  MODELO_EXCLUIDO: 'Modelo excluído com sucesso.',
  FORM_INVALIDO: 'Verifique todos os campos obrigatórios.',
  ENCERRAR_EDITAL: 'Tem certeza que deseja encerrar o edital vigente?',
  REABRIR_EDITAL: 'Tem certeza que deseja reabrir o edital?',
  USUARIO_EXISTENTE: 'Já existe um usuário cadastrado na plataforma com este CPF. Não é possível se cadastrar como credenciado.',
  DATA_MODAL_EDITAL_INVALIDA: 'A data de encerramento deve ser superior ao dia atual.',
  ARQUIVO_EXTENSION_FAIL: 'Extensão de arquivo não pode ser diferente de: $$'
}

export default messages
